import {
  MEDICINE,
  MEDICINE_TYPE,
  DRUG_CLASSIFICATION,
  DOSAGE_FORM
} from '../actionTypes'

// Initial state for each entity
const createInitialState = () => ({
  data: [],
  total: 0,
  params: { limit: 10, offset: 0, q: '' },
  loading: false,
  error: null,
  success: null
})

// Create reducer for a specific entity type
const createEntityReducer = (types) => {
  const initialState = createInitialState()
  
  return (state = initialState, action) => {
    switch (action.type) {
      // List actions
      case types.LIST_REQUEST:
        return Object.assign({}, state, { loading: true, error: null })
        
      case types.LIST_SUCCESS:
        return Object.assign({}, state, {
          loading: false,
          data: action.data,
          total: action.total,
          params: action.params || {},
          error: null
        })
        
      case types.LIST_FAILURE:
        return Object.assign({}, state, { 
          loading: false, 
          data: [], 
          total: 0,
          error: action.error || 'Failed to load data'
        })
      
      // Create actions
      case types.CREATE_REQUEST:
        return Object.assign({}, state, { 
          loading: true, 
          error: null, 
          success: null 
        })
        
      case types.CREATE_SUCCESS:
        return Object.assign({}, state, {
          loading: false,
          data: [action.data].concat(state.data),
          total: state.total + 1,
          success: 'Successfully created',
          error: null
        })
        
      case types.CREATE_FAILURE:
        return Object.assign({}, state, { 
          loading: false, 
          error: action.error,
          success: null
        })
      
      // Update actions
      case types.UPDATE_REQUEST:
        return Object.assign({}, state, { 
          loading: true, 
          error: null, 
          success: null 
        })
        
      case types.UPDATE_SUCCESS:
        return Object.assign({}, state, {
          loading: false,
          data: state.data.map(function(item) {
            return item.uuid === action.data.uuid ? action.data : item
          }),
          success: 'Successfully updated',
          error: null
        })
        
      case types.UPDATE_FAILURE:
        return Object.assign({}, state, { 
          loading: false, 
          error: action.error,
          success: null
        })
      
      // Delete actions
      case types.DELETE_REQUEST:
        return Object.assign({}, state, { 
          loading: true, 
          error: null, 
          success: null 
        })
        
      case types.DELETE_SUCCESS:
        return Object.assign({}, state, {
          loading: false,
          data: state.data.filter(function(item) { 
            return item.uuid !== action.uuid 
          }),
          total: Math.max(0, state.total - 1),
          success: 'Successfully deleted',
          error: null
        })
        
      case types.DELETE_FAILURE:
        return Object.assign({}, state, { 
          loading: false, 
          error: action.error,
          success: null
        })
      
      // Clear notification
      case types.CLEAR_NOTIFY:
        return Object.assign({}, state, { 
          error: null, 
          success: null 
        })
        
      default:
        return state
    }
  }
}

// Combine all reducers
const medicineReducer = createEntityReducer(MEDICINE)
const medicineTypeReducer = createEntityReducer(MEDICINE_TYPE)
const drugClassificationReducer = createEntityReducer(DRUG_CLASSIFICATION)
const dosageFormReducer = createEntityReducer(DOSAGE_FORM)

export {
  medicineReducer,
  medicineTypeReducer,
  drugClassificationReducer,
  dosageFormReducer
}

